import { getCompanyInfo } from '@/api/sys' // 假设你有这个API接口

export default {
  namespaced: true,
  state: {
    id: 0,
    skuTags: [],
    defalutSku: {
      price: 0, // 销售价
      oriPrice: 0, // 市场价
      stocks: 0, // 库存
      properties: '', // 销售属性组合字符串
      skuName: '', // sku名称
      prodName: '', // 商品名称
      weight: 0, // 商品重量
      volume: 0, // 商品体积
      status: 1 // 0 禁用 1 启用
    },
    companyList: [],
    bigScreen: {
      // 仓库
      godownId: '',
      godownType: '',
      godownName: '',
    }
  },
  mutations: {
    updateSkuTags (state, skuTags) {
      state.skuTags = skuTags
    },
    addSkuTag (state, skuTag) {
      state.skuTags.push(skuTag)
    },
    removeSkuTag (state, tagIndex) {
      state.skuTags.splice(tagIndex, 1)
    },
    removeSkuTagItem (state, {tagIndex, tagItemIndex}) {
      state.skuTags[tagIndex].tagItems.splice(tagItemIndex, 1)
    },
    addSkuTagItem (state, {tagIndex, tagItem}) {
      state.skuTags[tagIndex].tagItems.push(tagItem)
    },
    SET_COMPANY_LIST (state, list) {
      state.companyList = list
    },
    setWarehouse (state, data) {
      state.bigScreen = Object.assign(state.bigScreen, data)
    }
  },
  actions: {
    async getCompanyList ({ commit }) {
      try {
        const { data } = await getCompanyInfo()
        commit('SET_COMPANY_LIST', data)
      } catch (error) {
        console.error('获取公司列表失败:', error)
      }
    }
  },
}
